import { ChangeEvent, useState } from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Col, Row } from "react-grid-system";

import { StyledModal } from "../../styles/StyledModal";
import { CreateUser } from "../CreateUser";
import Modal from "../Modal";
import { Button } from "../Button";
import AddIcon from "../../assets/img/icons/add.svg";
import { UsersList } from "../UsersList";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useQuery } from "react-query";
import { getUsers, UserType } from "../../api/admin/user";
import { QueryLoader } from "../Loader";
import { StyledField } from "../../styles/StyledField";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useDebounce } from "@uidotdev/usehooks";

export const Users = () => {
	const { axiosPrivate } = useAxiosPrivate();
	const [searchValue, setSearchValue] = useState("");
	const debouncedSearchValue = useDebounce(searchValue, 500);

	const { isLoading, isError, data, error, refetch } = useQuery<UserType[]>(["users", debouncedSearchValue], () =>
		getUsers(axiosPrivate, debouncedSearchValue)
	);
	const [modalIsOpen, setModalIsOpen] = useState(false);

	const closeModal = () => {
		setModalIsOpen(false);
	};

	const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
		setSearchValue(e.target.value);
	};

	if (isError) {
		console.error(error);
		return (
			<Row>
				<Col>Something went wrong...</Col>
			</Row>
		);
	}

	return (
		<>
			<Row>
				<Col>
					<StyledField>
						<label>Search</label>
						<input placeholder="search by username, name, email" value={searchValue} onChange={handleInput} />
					</StyledField>
				</Col>
			</Row>
			<Row>
				<Col>{isLoading ? <QueryLoader /> : <UsersList refetchUsers={refetch} users={data} />}</Col>
			</Row>

			<Row style={{ marginTop: "2rem" }}>
				<Col>
					<Button 
						icon={AddIcon} 
						onClick={() => setModalIsOpen(true)}
						alabel="Add User"
						testid="add-user-button"
						initial={false}
					>
						Add
					</Button>
				</Col>
			</Row>
			<Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={StyledModal} ariaHideApp={false}>
				<CreateUser refetchUsers={refetch} closeModal={closeModal} />
			</Modal>
		</>
	);
};
